<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="dimensions"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Complexity management
                    </b>
                </div>
            </div>
        </div>
        <div class="middle-part set-up"><div class="current-status">
            <div class="left">
                <div class="dot"></div>
                <div class="dot green"></div>
            </div>
            <div class="divider"></div>
            <div class="right">
                <div class="wrap">
                    Select the top <b class="text-bracket" >{{columnName}}</b> values that you would like to break-out in the analysis: click on a value to toggle.
                </div>
                <div class="wrap">
                    <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true, 'btn-green':true, 'btn-small':true}">Continue</button> when done or <a [routerLink]="['/complexity-mgnt']" [queryParams]="{projectId: projectId}" [ngClass]="{'btn':true, 'btn-gray':true, 'btn-small':true}">Cancel</a>
                </div>
            </div>
        </div>
        <div [ngClass]="{'loading': loading, 'table-country':true}">
            <table>
                <thead>
                <tr>
                    <th>
                        <span class="cell-title">Relevance</span>
                        <help-link helpId="30"></help-link>
                        <a (click)="sort(TopValsSort.Relevance)" class="icon-sort">
                            <img *ngIf="sortBy != TopValsSort.Relevance" src="assets/images/icon-arrows-sorting.svg" alt="">
                            <img *ngIf="sortBy == TopValsSort.Relevance && sortAsc" src="assets/images/icon-arrows-sorting-asc.svg" alt="">    
                            <img *ngIf="sortBy == TopValsSort.Relevance && !sortAsc" src="assets/images/icon-arrows-sorting-desc.svg" alt="">
                        </a>
                    </th>
                    <th>
                        <span class="cell-title">{{columnName}}</span>
                        <a (click)="sort(TopValsSort.Value)" class="icon-sort">
                            <img *ngIf="sortBy != TopValsSort.Value" src="assets/images/icon-arrows-sorting.svg" alt="">
                            <img *ngIf="sortBy == TopValsSort.Value && sortAsc" src="assets/images/icon-arrows-sorting-asc.svg" alt="">    
                            <img *ngIf="sortBy == TopValsSort.Value && !sortAsc" src="assets/images/icon-arrows-sorting-desc.svg" alt="">
                        </a>
                    </th>
                    <th>
                        <span class="cell-title">Complexity</span>
                        <help-link helpId="31"></help-link>
                        <a  (click)="sort(TopValsSort.Complexity)"class="icon-sort">
                            <img *ngIf="sortBy != TopValsSort.Complexity" src="assets/images/icon-arrows-sorting.svg" alt="">
                            <img *ngIf="sortBy == TopValsSort.Complexity && sortAsc" src="assets/images/icon-arrows-sorting-asc.svg" alt="">    
                            <img *ngIf="sortBy == TopValsSort.Complexity && !sortAsc" src="assets/images/icon-arrows-sorting-desc.svg" alt="">
                        </a>
                    </th>
                    <th>
                        <span class="cell-title">Outcomes</span>
                        <help-link helpId="32"></help-link>
                        <a (click)="sort(TopValsSort.Outcomes)" class="icon-sort">
                            <img *ngIf="sortBy != TopValsSort.Outcomes" src="assets/images/icon-arrows-sorting.svg" alt="">
                            <img *ngIf="sortBy == TopValsSort.Outcomes && sortAsc" src="assets/images/icon-arrows-sorting-asc.svg" alt="">    
                            <img *ngIf="sortBy == TopValsSort.Outcomes && !sortAsc" src="assets/images/icon-arrows-sorting-desc.svg" alt="">
                        </a>
                    </th>
                    <th>
                        <span class="cell-title">Variance</span>
                        <help-link helpId="33"></help-link>
                        <a (click)="sort(TopValsSort.Variance)" class="icon-sort">
                            <img *ngIf="sortBy != TopValsSort.Variance" src="assets/images/icon-arrows-sorting.svg" alt="">
                            <img *ngIf="sortBy == TopValsSort.Variance && sortAsc" src="assets/images/icon-arrows-sorting-asc.svg" alt="">    
                            <img *ngIf="sortBy == TopValsSort.Variance && !sortAsc" src="assets/images/icon-arrows-sorting-desc.svg" alt="">
                        </a>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let val of values; let i = index" [ngClass]="{'selected':val.selected}">
                    <td>
                        {{val.relevance}}
                    </td>
                    <td (click)="val.selected = !val.selected" class="cursor-pointer">
                        <a class="cell-country">
                            {{val.value}}
                        </a>
                    </td>
                    <td [style.background-color]="val.complexityColor"></td>
                    <td [style.background-color]="val.outcomesColor"></td>
                    <td [style.background-color]="val.varianceColor"></td>
                </tr>
                </tbody>
            </table>
        </div>
        </div>
    </div>
</main>
